module.exports = __webpack_public_path__ + "media/images/landing_page/775074-a31b7893e47e6917d0272efd542cab63.webp";